import React, { Component, Fragment } from 'react';
import { arrayOf, object, shape, string, func } from 'prop-types';
import FilterContainer, { Subscribe } from 'js/containers/filter';
import Filter from 'components/filter/component';
import Result from './result';

class DataPeriodicReleaseArchiveFilter extends Component {

    static propTypes = {
        config: shape( {
            attributes: shape( {
                data: shape( {
                    filters: arrayOf( shape( {
                        name: string.isRequired,
                        facets: arrayOf( shape( {
                            name: string.isRequired,
                            query: object.isRequired
                        } ) )
                    } ) ).isRequired,
                    results: arrayOf( shape( {
                        title: string.isRequired,
                        results: arrayOf( shape( {
                            attributes: {
                                title: string.isRequired,
                                url: string.isRequired,
                                year: string.isRequired,
                                icon: shape( {
                                    src: string.isRequired,
                                    alt: string.isRequired,
                                    text: string.isRequired
                                } )
                            }
                        } ) ).isRequired
                    } ) ).isRequired
                } )
            } )
        } ).isRequired,
        container: shape( {
            state: object,
            updateStatefromData: func.isRequired
        } ).isRequired
    };

    constructor( props ) {

        super( props );

        const currentYearValue = {
            label: 'All',
            value: 'All'
        };

        this.state = {
            currentResult: this.getResults( currentYearValue ),
            page: 1,
            currentYearValue
        };

    }

    getResults = ( currentYearValue ) => {

        const resultGroups = this.props.config.results.map( ( result ) => {

            const results = result.results.filter( ( items ) => {

                if ( currentYearValue.value === 'All' ) {

                    return true;

                }

                return items.attributes.year === currentYearValue.value;

            } );

            return {
                title: result.title,
                id: result.id,
                results: results
            };

        } );

        return resultGroups;

    };

    onFilterChange = ( selectedOption ) => {

        const result = this.getResults( selectedOption );

        this.setState( {
            currentYearValue: selectedOption,
            currentResult: result,
            page: 1
        } );

    };

    renderFilters = () => {

        return this.props.config.filters.map( ( filter ) => {

            return (
                <Filter
                    key={ filter.name }
                    filter={ filter }
                    labelId='filter-title'
                    onChange={ this.onFilterChange }
                    container={ this.props.container }
                    updateState={ this.props.container.updateStatefromData }
                    value={ this.state.currentYearValue }

                />
            );

        } );

    };

    changePrevPage = ( e ) => {

        this.renderPagination( this.state.page, this.updatePageFromPagination );

        this.setState( { page: this.state.page - 1 } );

    };

    changeNextPage = ( e ) => {

        this.setState( { page: this.state.page + 1 } );

    };

    updatePageFromPagination = ( e ) => {

        this.setState( { page: parseInt( e.target.innerHTML, 10 ) } );

    };

    renderPagination = ( page, updateFunc, divisor ) => {

        const totalPages = Math.ceil( this.state.currentResult[0].results.length / divisor );
        const maxDisplayedPagination = 5;
        const newPages = [];

        if ( totalPages > maxDisplayedPagination ) {

            // page will be 1 at the lowest, but once we move away from
            // page 3, we need to just subtract 2 from our page.
            // When we approach 2 pages away from the end of our data,
            // we need to subtract another page for each page closer we get.
            const lowEnd = this.state.page - 2 >= 1
                ? totalPages - this.state.page >= 2
                    ? this.state.page - 2
                    : this.state.page - 2 - ( 2 - totalPages % this.state.page )
                : 1;

            // once we hit page 3, we need to start moving the pagination buttons
            // over on each 'next' hit. Once we get less than 2 pages away from our
            // total pages, our high end should just be 4 away from the low end to
            // keep our range of 5 pages.
            const highEnd = this.state.page + 2 >= totalPages
                ? totalPages
                : lowEnd + 4;

            for ( let i = lowEnd; i <= highEnd; i += 1 ) {

                newPages.push( i );

            }

        }
        else if ( totalPages > 1 ) {

            for ( let i = 1; i <= totalPages; i += 1 ) {

                newPages.push( i );

            }

        }

        const paginationButtons = newPages.map( function ( i ) {

            return (
                <a
                    key={ `paginationkey${ i }` } onClick={ updateFunc }
                    className={ [ page === i ? 'selected' : '', 'pagination-btn' ].join( ' ' ) }
                >
                    { i }
                </a>
            );

        } );

        return paginationButtons;

    };

    renderResults = () => {

        const divisor = this.state.currentResult.length < 2 ? 20 : 12;

        return (
            <div className={ [ this.state.currentResult.length === 1
                ? 'data-periodic-release-archive-filter-result-wrapper-fullwidth'
                : '', 'data-periodic-release-archive-filter-result-wrapper' ].join( ' ' ) }
            >
                {
                    this.state.currentResult.map( ( result ) => {

                        return <Result key={ result.id } { ...{
                            prev: this.changePrevPage,
                            next: this.changeNextPage,
                            update: this.updatePageFromPagination,
                            page: this.state.page,
                            paginationButtons: this.renderPagination( this.state.page, this.updatePageFromPagination, divisor ),
                            divisor: divisor,
                            result: result
                        } }
                        />;

                    } )
                }
            </div>
        );

    };

    render() {

        return (
            <Fragment>
                <div className='link-grid-with-filters-body-filter'>
                    <p className='filter-title'>Filter by:</p>

                    <div className='filter-section'>
                        { this.renderFilters() }
                    </div>
                </div>
                <hr className='link-grid-with-filters-body-separator'></hr>
                { this.renderResults() }

            </Fragment>

        );

    }

}

const withSubscribe = ( props ) => (
    <Subscribe to={ [ FilterContainer ] }>
        { ( container ) => (
            <DataPeriodicReleaseArchiveFilter
                config={ props.config.attributes.data }
                data={ container.state }
                container={ container }
            />
        ) }
    </Subscribe>
);

withSubscribe.propTypes = DataPeriodicReleaseArchiveFilter.propTypes.config;

export default withSubscribe;